module.exports = __webpack_public_path__ + "static/media/AppIcon-IC3639.b7951846.png";